module.exports = __webpack_public_path__ + "static/media/2_1.b55301c8.png";